// src/utils/notificationUtils.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export const createNotification = async ({
  userId,
  fromUserId,
  fromUsername,
  type,
  postId = null,
  commentId = null,
  commentText = null,
  badgeName = null,
  streakDays = null,
  taskName = null,
  goalTitle = null,
  studyHours = null,
}) => {
  try {
    if (userId === fromUserId) return; // Kendine bildirim gönderme

    await addDoc(collection(db, "notifications"), {
      userId,
      fromUserId,
      fromUsername,
      type,
      postId: postId || null,
      commentId: commentId || null,
      commentText: commentText || null,
      badgeName: badgeName || null,
      streakDays: streakDays || null,
      taskName: taskName || null,
      goalTitle: goalTitle || null,
      studyHours: studyHours || null,
      timestamp: serverTimestamp(),
      read: false,
    });
  } catch (err) {
    console.error("❌ Bildirim oluşturulamadı:", err);
  }
};